'use strict';

var DataExtractToolbarController = function DataExtractToolbarController() {};
DataExtractToolbarController.$inject = [];
module.exports = DataExtractToolbarController;